import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class DeviceService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/v1/devices`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async delete(uuid) {
    return await this.destroy(`/v1/devices/${uuid}`);
  }

  async edit(uuid, params) {
    return await this.update(`/v1/devices/${uuid}`, params);
  }
}

export default DeviceService;



// WEBPACK FOOTER //
// ./src/core/service/device.service.js